// file created at 2020-1-19
// Auto-generated files D3AnimationTest.ts

import { Vue, Component } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({})
export default class D3AnimationTest extends Vue {
  private mounted() {
    //
    const svg = d3.select('svg');

    console.log('svg', svg);

    // 기존 데이터
    const data1 = [1, 2, 3, 4];
    // 새로 갱신할 데이터
    const data2 = [5, 6, 7, 8, 9];

    // *data1으로 circle을 그린다
    svg
      .selectAll('circle')
      .data(data1)
      .enter()
      .append('circle')
      .attr('cx', d => d * 10)
      .attr('cy', 10)
      .attr('r', 10)
      .attr('fill', 'black');

    // *data2로 circle들을 갱신한다.
    const circles = svg.selectAll('circle').data(data2);

    circles
      .attr('cx', d => d * 10) // 기존 데이터가 4개 있었으니 4개가 갱신되고
      .attr('cy', 10)
      .attr('r', 10)
      .attr('fill', 'black');

    circles.on('click', d => {
      // console.log('d', d);
      data2[0] = 14;

      svg
        .selectAll('circle')
        .data(data2)
        .transition()
        .duration(500)
        .attr('cx', dd => dd * 10)
        .attr('cy', 10)
        .attr('r', 10)
        .attr('fill', 'black');
    });

    circles
      .enter() // 아래는 새로운 데이터 1개 더 생성되었으니 1개가 생성된다.
      .append('circle')
      .attr('cx', d => d * 10)
      .attr('cy', 10)
      .attr('r', 10)
      .attr('fill', 'black');
  }
}
